export default {
    'home.title.back_office': 'Back Office',
    'home.title.team_member_portal': 'Team Member Portal',
    'home.title.start_page_title': 'What would you like to do today?',

    'home.label.show_descriptions': 'Show Descriptions',

    'home.placeholder.feature_finder': 'Feature Finder',

    // Onboarding Widget
    'home.onboarding.widget.title': 'Complete your setup',
    'home.onboarding.widget.remaining': '{remaining} of {total} tasks remaining',

    // Onboarding Tasks
    'home.onboarding.title': "Welcome {tenantName}! You're gonna to love it here.",
    'home.onboarding.progress': 'Complete {currentStep} of {totalSteps} • {progressPercentage}%',
    'home.onboarding.description': "We've suggested some activities for you to get started. You can skip any you don't want to do right now.",
    'home.onboarding.badge.skipped': 'Skipped',
    'home.onboarding.button.skip': 'Skip for now',
    'home.onboarding.button.undo_skip': 'Undo Skip',

    // Task Descriptions
    'home.onboarding.task.import_contacts': 'Import your customers and suppliers to start managing relationships.',
    'home.onboarding.task.import_journals': 'Import historical journal entries to maintain your accounting records.',
    'home.onboarding.task.import_team_members': 'Add your team members and set up their roles and permissions.',
    'home.onboarding.task.import_services': 'Import your service offerings to use in invoices and estimates.',
    'home.onboarding.task.import_products': 'Import your product catalog for inventory management.',
    'home.onboarding.task.invite_users': 'Invite your accountant, bookkeeper, or team members to collaborate.',
    'home.onboarding.task.create_service': 'Create your first service offering to use in invoices and estimates.',
    'home.onboarding.task.create_bank_account': 'Set up your first bank account to start tracking transactions.',

    // Completion Modal
    'home.onboarding.modal.title': "Congratulations! You're all set up!",
    'home.onboarding.modal.description': 'Your HeadOffice is now ready to be used.',
    'home.onboarding.modal.button': "Let's get started!",
};
